import React from "react";

interface ProgressBarProps {
  progress: number;
  bgColor?: string;
  fillColor?: string;
  MB?: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  bgColor = "#EAECF0",
  fillColor = "#D1A960",
  MB = 16,
}) => {
  return (
    <div
      className={`w-[90%]  lg:w-[33%] md:w-[45%] sm:w-[60%] mx-auto rounded-lg overflow-hidden mb-8 sm:mb-${MB}  mt-4 sm:mt-8 h-[6px]`}
      style={{ backgroundColor: bgColor }}
    >
      <div
        className="rounded-lg h-full"
        style={{
          width: `${Math.min(Math.max(progress, 0), 100)}%`,
          backgroundColor: fillColor,
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
